// extracted by mini-css-extract-plugin
export default {"markRow":"table1_markRow__6f5K4"};